export enum ShareBaseAction {
    RequestRight = 'REQUEST_RIGHT'
};


// WEBPACK FOOTER //
// ./src/sharebase/domain/sharebase.actions.ts